import { ValidUtils } from "../valid/ValidUtils.js";
var StringUtils;
((StringUtils2) => {
  StringUtils2.deleteEnter = (data) => {
    return data.replace(/\r?\n/g, "");
  };
  StringUtils2.pickEmoji = (data) => {
    return data.match(/[\p{Emoji}]/gu) ?? [];
  };
  StringUtils2.regexExec = (regex, text) => {
    let varExec = regex.exec(text);
    const usingVars = [];
    while (varExec) {
      usingVars.push(varExec);
      varExec = regex.exec(varExec.input);
    }
    return usingVars;
  };
  StringUtils2.escapeSpecialCharacterRegExp = (data) => {
    return data.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };
  StringUtils2.trim = (data) => data.trim();
  StringUtils2.rsubString = (data_s, blen_n) => data_s.substring(data_s.length - blen_n, data_s.length);
  StringUtils2.lsubString = (data_s, alen_n) => data_s.substring(0, alen_n);
  StringUtils2.lpad = (fill_s, len_n, full_s) => {
    while (len_n > full_s.length) {
      full_s = fill_s + full_s;
    }
    return StringUtils2.rsubString(full_s, len_n);
  };
  StringUtils2.rpad = (fill_s, len_n, full_s) => {
    while (len_n > full_s.length) {
      full_s += fill_s;
    }
    return StringUtils2.lsubString(full_s, len_n);
  };
  StringUtils2.lappend = (count_n, input_s) => {
    let s = "";
    let i = 0;
    while (i++ < count_n) {
      s += input_s;
    }
    return s;
  };
  StringUtils2.unescape = (html) => {
    if (!html) return "";
    const htmlEntity = {
      quot: '"',
      amp: "&",
      apos: "'",
      lt: "<",
      gt: ">",
      nbsp: "\xA0",
      iexcl: "\xA1",
      cent: "\xA2",
      pound: "\xA3",
      curren: "\xA4",
      yen: "\xA5",
      brvbar: "\xA6",
      sect: "\xA7",
      uml: "\xA8",
      copy: "\xA9",
      ordf: "\xAA",
      laquo: "\xAB",
      not: "\xAC",
      shy: "\xAD",
      reg: "\xAE",
      macr: "\xAF",
      deg: "\xB0",
      plusmn: "\xB1",
      sup2: "\xB2",
      sup3: "\xB3",
      acute: "\xB4",
      micro: "\xB5",
      para: "\xB6",
      middot: "\xB7",
      cedil: "\xB8",
      sup1: "\xB9",
      ordm: "\xBA",
      raquo: "\xBB",
      frac14: "\xBC",
      frac12: "\xBD",
      frac34: "\xBE",
      iquest: "\xBF",
      "#x27": "'"
    };
    return html.replace(/&((?:(?:[a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});?)+);/gi, (match, entity) => {
      const entities = entity.toLowerCase().split(";");
      return entities.map((it) => it in htmlEntity ? htmlEntity[it] : match).join("");
    });
  };
  StringUtils2.executeExpression = (formatString, object) => {
    return formatString.replace(/\${([^{}]*)}/g, (matched, piece) => String(object[piece] ?? matched));
  };
  StringUtils2.ellipsis = (text, length) => {
    if (text.length > length) return `${text.slice(0, length)}...`;
    return text;
  };
  StringUtils2.appendPostposition = (text, { vowel, consonant }) => {
    return `${text}${ValidUtils.lastConsonantLetter(text) ? consonant : vowel}`;
  };
  StringUtils2.replaceSequentially = (text, replacements) => {
    let remainingText = text;
    let result = "";
    while (remainingText.length > 0) {
      let bestMatch = null;
      for (const replacement of replacements) {
        const newRegex = new RegExp(replacement.regex);
        const match = newRegex.exec(remainingText);
        if (match) {
          if (bestMatch === null || match.index < bestMatch.index) {
            bestMatch = { index: match.index, match, replacement };
          }
        }
      }
      if (bestMatch) {
        const { index, match, replacement } = bestMatch;
        const matchedString = match[0];
        result += remainingText.substring(0, index);
        result += replacement.callback(matchedString);
        remainingText = remainingText.substring(index + matchedString.length);
      } else {
        result += remainingText;
        break;
      }
    }
    return result;
  };
})(StringUtils || (StringUtils = {}));
export {
  StringUtils
};
//# sourceMappingURL=StringUtils.js.map
